@if (assetGroupTransactions$ | async; as assetGroupTransactions) {
  <bp-tile
    class="recent-activities"
    [padding]="false"
    [title]="'activity_dashboard' | translate">
    <ng-container tile-actions>
      @if (assetGroupTransactions.length > 0) {
        <a class="font-medium" [routerLink]="['/my-account/history']">
          {{ "dashboard_activities_view_more" | translate }}
        </a>
      }
    </ng-container>
    @if (assetGroupTransactions.length > 0) {
      <bp-tabs>
        @for (assetGroup of assetGroupTransactions; track assetGroup.filter.name) {
          <bp-tab-item [label]="assetGroup.filter.name | translate">
            @for (date of assetGroup.txDates; track date) {
              <div class="font-size-12 font-semibold date-container pr-20 pl-20">{{ date }}</div>
              @for (transaction of assetGroup.transactions[date]; track transaction.getId()) {
                <div class="item-container of-tnum">
                  @if (isTradableTx(transaction)) {
                    <tradable-transaction-list-item
                      compact
                      [activity]="'activity'"
                      [transaction]="transaction"
                      class="activity-widget-list"
                      [focusable]="true"
                      [isWidget]="true">
                    </tradable-transaction-list-item>
                  }
                  @if (isFiatTx(transaction)) {
                    <fiat-transaction-list-item
                      compact
                      [activity]="'activity'"
                      [transaction]="transaction"
                      class="activity-widget-list"
                      [focusable]="true"
                      [isWidget]="true">
                    </fiat-transaction-list-item>
                  }
                </div>
              }
            }
          </bp-tab-item>
        }
      </bp-tabs>
    } @else {
      <bp-tabs>
        <bp-tab-item>
          <empty [headline]="'no_transactions_made' | translate" [loading]="false"></empty>
        </bp-tab-item>
      </bp-tabs>
    }
    <ng-template #empty>
      <bp-tabs>
        <bp-tab-item>
          <empty [headline]="'no_transactions_made' | translate" [loading]="false"></empty>
        </bp-tab-item>
      </bp-tabs>
    </ng-template>
  </bp-tile>
}
